import { logout } from "appState/auth/authSlice";
import {
  TKIconDBArrowLeft,
  TKIconDBArrowRight,
  TKIconLogout,
} from "assets/images/svgs";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import CompanyLogo from "shared/CompanyLogo";
import styled from "styled-components";
import { SidebarContent } from "utilities/sidebarContent";

function Sidebar() {
  const [toggle, setToggle] = useState(true);
  function handleToggle() {
    setToggle(!toggle);
  }

  const dispatch = useDispatch();
  return (
    <SidebarContainer>
      <div>
        <div className="flex justify-center items-center gap-x-2">
          {toggle && <div className="hidden md:block">{<CompanyLogo />}</div>}
          <div className="  md:block">
            {toggle ? (
              <TKIconDBArrowLeft
                className="cursor-pointer"
                onClick={handleToggle}
              />
            ) : (
              <TKIconDBArrowRight
                className="cursor-pointer"
                onClick={handleToggle}
              />
            )}
          </div>
        </div>
        <SidebarLinkWrapper>
          {SidebarContent.slice(0, 4).map(({ route, icon, text }) => {
            return (
              <NavLink
                key={Math.random()}
                to={route}
                className={({ isActive }) =>
                  `nav-link text-white flex justify-start items-start max-md:justify-center ${
                    isActive ? "nav-link--selected" : ""
                  }`
                }
              >
                <span>{icon}</span>
                {toggle && (
                  <SideNavLinkText className="hidden md:block">
                    {text}
                  </SideNavLinkText>
                )}
              </NavLink>
            );
          })}
          <hr className="bg-[#ffffffa2]" />
          {SidebarContent.slice(4, 5).map(({ route, icon, text }) => {
            return (
              <NavLink
                key={Math.random()}
                to={route}
                className={({ isActive }) =>
                  `nav-link text-white flex justify-start items-start max-md:justify-center ${
                    isActive ? "nav-link--selected" : ""
                  }`
                }
              >
                <span>{icon}</span>
                {toggle && (
                  <SideNavLinkText className="hidden md:block">
                    {text}
                  </SideNavLinkText>
                )}
              </NavLink>
            );
          })}
        </SidebarLinkWrapper>
      </div>
      <div
        onClick={() => dispatch(logout())}
        className={` ${
          toggle ? "sidebar__footer" : "flex flex-col items-center"
        }`}
      >
        <div
          className={`flex flex-col items-center md:block ${
            toggle && "md:pl-[33px]"
          }`}
        >
          <div
            className={`border border-secondaryColor mb-[30px] w-[40px] ${
              toggle ? "w-[40px] md:w-[90%]" : "w-[40px]"
            } h-[40px] rounded-[6px] flex items-center justify-center hover:opacity-70 cursor-pointer`}
          >
            <TKIconLogout />
            {toggle && (
              <p className="hidden md:block font-normal text-base ml-[11px]">
                Logout
              </p>
            )}
          </div>
        </div>
      </div>
    </SidebarContainer>
  );
}

export default Sidebar;

const SidebarContainer = styled.div.attrs({
  className: "bg-[#011F5B] text-white flex flex-col justify-center md:block",
})`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    padding: 24px 0;
  }
`;

const SideNavLinkText = styled.p`
  line-height: 17px;
  margin-right: 50px;
  font-size: 16px;
  /* color: rgba(255, 255, 255, 0.80); */
`;

const SidebarLinkWrapper = styled.div`
  margin-top: 42.5px;
  & > :first-child {
    margin-bottom: 15px;
    padding-left: 33px;
  }

  .nav-link {
    white-space: nowrap;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 20.35px;
    padding: 10px 30.583px 10px 30.583px;
    margin: 10px 0 20px 0;
    &--selected {
      span {
        .svg-icon {
          stroke: #f0ca18;
        }
      }
      p {
        color: #f0ca18;
      }
    }
    @media only screen and (min-width: 768px) {
      padding: 10px 30.583px 10px 15.583px;
    }
  }
`;
